import {VictoryPointTypes} from '@colonist/game-base-types'

export abstract class BaseVictoryPointData {
    abstract victoryPointType: VictoryPointTypes
    abstract value: number
    abstract private: boolean
}
